var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "news-card col-tablet-12",
      attrs: {
        href: _vm.isFileCanBeDownloaded
          ? _vm.newsInfo.file.link
          : _vm.newsInfo.detailPageUrl,
        download: !!_vm.isFileCanBeDownloaded ? _vm.newsInfo.name : null,
        target: _vm.isFileCanBeDownloaded ? "_blank" : "_self",
      },
    },
    [
      _c(
        "div",
        { staticClass: "news-card__content col-default-8 col-tablet-12" },
        [
          _c("date-block", {
            staticClass: "news-card__date",
            attrs: { date: _vm.newsDate, size: "s" },
          }),
          _vm._v(" "),
          _c(
            "z-caption",
            { staticClass: "news-card__title", attrs: { tag: "h3" } },
            [
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.newsInfo.name) },
              }),
              _vm._v(" "),
              _vm.isFileCanBeDownloaded
                ? _c("span", { staticClass: "news-card__title-tag" }, [
                    _vm._v("PDF"),
                  ])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.newsInfo.category || _vm.newsInfo.type.value
            ? _c(
                "div",
                { staticClass: "news-card__tags" },
                [
                  _vm.newsInfo.type.value === "Пресс-релиз" ||
                  _vm.newsInfo.type.value === "Press Release"
                    ? _c(
                        "tag",
                        {
                          staticClass: "news-card__tags-item",
                          attrs: { theme: "peach" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.newsInfo.type.value) +
                              "\n            "
                          ),
                        ]
                      )
                    : _c(
                        "tag",
                        {
                          staticClass: "news-card__tags-item",
                          attrs: { theme: "gray" },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.newsInfo.type.value) +
                              "\n            "
                          ),
                        ]
                      ),
                  _vm._v(" "),
                  _vm._l(_vm.newsInfo.category, function (tag, index) {
                    return _c(
                      "tag",
                      {
                        key: index,
                        staticClass: "news-card__tags-item",
                        attrs: { theme: "gray" },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(tag.value) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.newsInfo.previewPicture && _vm.newsInfo.previewPicture.link
        ? _c("img", {
            staticClass: "news-card__img col-default-2 hide-me--tablet",
            attrs: {
              src: _vm.newsInfo.previewPicture.link || "",
              alt: _vm.newsInfo.previewPicture.name || "",
            },
          })
        : _c("img", {
            staticClass:
              "news-card__img col-default-2 col-tablet-4 hide-me--tablet",
            attrs: { src: "/images/news/dummyimage.webp", alt: "" },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }